import React from "react";
import { Route } from "react-router-dom";
import loadable from "@loadable/component";
import {
  FEATURE_DETAILS_ENDPOINT,
  PIT_STOP_DETAILS_ENDPOINT,
  NEWS_DETAILS_ENDPOINT,
  PAGE_TYPE,
  LIVE_NEWS_DETAILS_ENDPOINT,
  COMPARISION_TEST_ENDPOINT,
  ROAD_TEST_ENDPOINT,
  HINDI_NEWS_DETAILS_ENDPOINT,
  HINDI_ROAD_TEST_ENDPOINT,
  HINDI_COMPARISION_TEST_ENDPOINT,
  HINDI_FEATURE_DETAILS_ENDPOINT,
  AUTOEXPO_NEWS_ENDPOINT,
} from "../constants/Global";
import { IMAGES_ENDPOINTS, COLORS_ENDPOINTS } from "../constants/Images.js";
import { PageLoader } from "GlobalComponent/PageLoader.js";
import { isVernacularPage } from "GlobalUtils/Vernacular";
import { page as pageEnum } from "GlobalEnum/Page";
import { VIDEO_DETAILS_ENDPOINTS } from "../constants/Videos";
import { Pages } from "GlobalEnum/NewPage";

const EditorialDetails = loadable(
  () =>
    import(
      /* webpackChunkName: "editorialdetails-desktop" */ "../containers/EditorialDetails.desktop.js"
    ),
  {
    fallback: <PageLoader />,
  }
);

const ImageAndColourDetails = loadable(
  () =>
    import(
      /* webpackChunkName: "imagedetails-desktop" */ "../containers/ImageAndColourDetails.desktop.js"
    ),
  {
    fallback: <PageLoader />,
  }
);

const VideosDesktop = loadable(
  () =>
    import(/* webpackChunkName: "videos-desktop" */ "../containers/Videos.js"),
  {
    fallback: <PageLoader />,
  }
);

const getKey = props => {
  const { makeMaskingName, modelMaskingName } = props.match.params;
  return `${makeMaskingName}-${modelMaskingName}-images`;
};

export const EditorialDetailsRoute = [
  <Route
    exact
    /*TODO: key is causing component tpo unmount on route change i.e news -> expert reviews or vice versa. NEED to fix it and add key*/
    path={NEWS_DETAILS_ENDPOINT}
    render={props => {
      let pageType = isVernacularPage()
        ? PAGE_TYPE.HINDI_NEWS
        : PAGE_TYPE.NEWS_DETAILS;
      return (
        <EditorialDetails
          {...props}
          pageType={pageType}
          pageId={pageEnum.EDITORIAL_DETAIL_PAGE_DESKTOP.id}
          newPageId={Pages.EDITORIAL_DETAIL.id}
        />
      );
    }}
  />,
  <Route
    exact
    path={ROAD_TEST_ENDPOINT}
    render={props => {
      let pageType = isVernacularPage()
        ? PAGE_TYPE.HINDI_EXPERT_REVIEWS
        : PAGE_TYPE.EXPERT_REVIEWS;
      return (
        <EditorialDetails
          {...props}
          pageType={pageType}
          pageId={pageEnum.EDITORIAL_DETAIL_PAGE_DESKTOP.id}
          newPageId={Pages.EDITORIAL_DETAIL.id}
        />
      );
    }}
  />,
  <Route
    exact
    path={COMPARISION_TEST_ENDPOINT}
    render={props => {
      let pageType = isVernacularPage()
        ? PAGE_TYPE.HINDI_EXPERT_REVIEWS
        : PAGE_TYPE.EXPERT_REVIEWS;
      return (
        <EditorialDetails
          {...props}
          pageType={pageType}
          pageId={pageEnum.EDITORIAL_DETAIL_PAGE_DESKTOP.id}
          newPageId={Pages.EDITORIAL_DETAIL.id}
        />
      );
    }}
  />,
  <Route
    exact
    path={FEATURE_DETAILS_ENDPOINT}
    render={props => {
      let pageType = isVernacularPage()
        ? PAGE_TYPE.HINDI_FEATURE_DETAILS
        : PAGE_TYPE.FEATURE_DETAILS;
      return (
        <EditorialDetails
          {...props}
          pageType={pageType}
          pageId={pageEnum.EDITORIAL_DETAIL_PAGE_DESKTOP.id}
          newPageId={Pages.EDITORIAL_DETAIL.id}
        />
      );
    }}
  />,
  <Route
    exact
    path={PIT_STOP_DETAILS_ENDPOINT}
    render={props => (
      <EditorialDetails
        {...props}
        pageType={PAGE_TYPE.PIT_STOP_DETAILS}
        pageId={pageEnum.EDITORIAL_DETAIL_PAGE_DESKTOP.id}
        newPageId={Pages.EDITORIAL_DETAIL.id}
      />
    )}
  />,
  <Route
    exact
    path={LIVE_NEWS_DETAILS_ENDPOINT}
    render={props => (
      <EditorialDetails
        {...props}
        pageType={PAGE_TYPE.LIVE_NEWS_DETAILS}
        pageId={pageEnum.EDITORIAL_DETAIL_PAGE_DESKTOP.id}
        newPageId={Pages.EDITORIAL_DETAIL.id}
      />
    )}
  />,
  <Route
    exact
    key="hindinews-detials"
    path={HINDI_NEWS_DETAILS_ENDPOINT}
    render={props => (
      <EditorialDetails
        {...props}
        pageType={PAGE_TYPE.HINDI_NEWS}
        pageId={pageEnum.EDITORIAL_DETAIL_PAGE_DESKTOP.id}
        newPageId={Pages.EDITORIAL_DETAIL.id}
      />
    )}
  />,
  <Route
    exact
    path={HINDI_ROAD_TEST_ENDPOINT}
    render={props => (
      <EditorialDetails
        {...props}
        pageType={PAGE_TYPE.HINDI_EXPERT_REVIEWS}
        pageId={pageEnum.EDITORIAL_DETAIL_PAGE_DESKTOP.id}
        newPageId={Pages.EDITORIAL_DETAIL.id}
      />
    )}
    key="hindi-road-test-detials"
  />,
  <Route
    exact
    path={HINDI_COMPARISION_TEST_ENDPOINT}
    render={props => (
      <EditorialDetails
        {...props}
        pageType={PAGE_TYPE.HINDI_EXPERT_REVIEWS}
        pageId={pageEnum.EDITORIAL_DETAIL_PAGE_DESKTOP.id}
        newPageId={Pages.EDITORIAL_DETAIL.id}
      />
    )}
    key="hindi-comparison-test-detials"
  />,
  <Route
    exact
    path={HINDI_FEATURE_DETAILS_ENDPOINT}
    render={props => (
      <EditorialDetails
        {...props}
        pageType={PAGE_TYPE.HINDI_FEATURE_DETAILS}
        pageId={pageEnum.EDITORIAL_DETAIL_PAGE_DESKTOP.id}
        newPageId={Pages.EDITORIAL_DETAIL.id}
      />
    )}
    key="hindi-features-detials"
  />,
  <Route
    exact
    path={AUTOEXPO_NEWS_ENDPOINT}
    render={props => (
      <EditorialDetails
        {...props}
        pageType={PAGE_TYPE.AUTOEXPO_NEWS}
        pageId={pageEnum.EDITORIAL_DETAIL_PAGE_DESKTOP.id}
        newPageId={Pages.EDITORIAL_DETAIL.id}
      />
    )}
    key="autoexpo-news-detials"
  />,
  <Route
    exact
    path={IMAGES_ENDPOINTS}
    render={props => (
      <ImageAndColourDetails
        {...props}
        pageType={PAGE_TYPE.IMAGE_DETAILS}
        pageId={pageEnum.IMAGE_DETAILS_DESKTOP.id}
        newPageId={Pages.IMAGE_DETAILS.id}
        key={getKey(props)}
      />
    )}
  />,
  <Route
    exact
    path={COLORS_ENDPOINTS}
    render={props => (
      <ImageAndColourDetails
        {...props}
        pageType={PAGE_TYPE.COLOUR_DETAILS}
        pageId={pageEnum.COLORS_PAGE_DESKTOP.id}
        newPageId={Pages.COLOR_DETAILS.id}
        key={getKey(props)}
      />
    )}
  />,
  <Route
    exact
    key="video-detials"
    path={VIDEO_DETAILS_ENDPOINTS}
    render={props => (
      <VideosDesktop
        {...props}
        pageType={PAGE_TYPE.VIDEO_DETAILS}
        isDesktop
        pageId={pageEnum.VIDEOS_DETAIL_PAGE_DESKTOP.id}
        newPageId={Pages.VIDEO_DETAILS.id}
        key={getKey(props)}
      />
    )}
  />,
];
